<template>
    <div class="container">
        <el-form :model="ruleForm" ref="ruleForm" label-width="180px">
            <div class="card-item">
                <div class="card-title">
                    <span>主体信息</span>
                </div>
                <div class="card-content">
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="统一社会信用代码 : " prop="mainCode" size="small">
                                <span>{{ruleForm.mainCode}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="主体名称 : " prop="mainName" size="small">
                                <span>{{ruleForm.mainName}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="法人机构类别 : " prop="agencyCode" size="small">
                                <span>{{ruleForm.agencyCodeName}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="交易主体角色类型 : " prop="roleTypeArr" size="small">
                                <el-checkbox-group v-model="ruleForm.roleTypeArr">
                                    <div class="all-deal-type">
                                        <div class="item-deal-type">
                                            <div class="item-deal-title">公共资源服务</div>
                                            <div class="item-deal-content">
                                                <el-row>
                                                    <el-col>
                                                        <el-checkbox disabled label="1">招标人/采购人/出让人</el-checkbox>
                                                    </el-col>
                                                </el-row>
                                                <el-row>
                                                    <el-col>
                                                        <el-checkbox disabled label="2">招标代理/采购代理/经纪代理</el-checkbox>
                                                    </el-col>
                                                </el-row>
                                                <el-row>
                                                    <el-col>
                                                        <el-checkbox disabled label="3">投标人/供应商/竞买人</el-checkbox>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                        </div>
                                        <div class="item-deal-type">
                                            <div class="item-deal-title">政务服务( 中介服务超市 )</div>
                                            <div class="item-deal-content">
                                                <el-row>
                                                    <el-col>
                                                        <el-checkbox disabled label="4">项目业主</el-checkbox>
                                                    </el-col>
                                                </el-row>
                                                <el-row>
                                                    <el-col>
                                                        <el-checkbox disabled label="5">涉批中介</el-checkbox>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                        </div>
                                    </div>
                                </el-checkbox-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="诚信承诺书 : " size="small">
                                <docUploadView
                                        :type="type"
                                        :docItem.sync="ruleForm.attachmentParamList[0]"
                                />
                            </el-form-item>
                            <el-form-item v-if="ruleForm.attachmentParamList[1]" label="法人授权委托书 : " size="small">
                                <docUploadView
                                        :type="type"
                                        :docItem.sync="ruleForm.attachmentParamList[1]"
                                />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="card-item">
                <div class="card-title">
                    <span>基本信息</span>
                </div>
                <div class="card-content">
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="营业执照 : " prop="businessPhotoAddr">
                                <imgUploadView v-if="ruleForm.businessPhotoAddr" :ruleForm.sync="ruleForm" :backgroundType="1" :imgUrl.sync="ruleForm.businessPhotoAddr"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="证书名称 : " prop="certName" size="small">
                                <span>{{ruleForm.certName}}</span>
                            </el-form-item>
                            <el-form-item label="颁发部门 : " prop="awardDepart" size="small">
                                <span style="margin-top: 4px;">{{ruleForm.awardDepart}}</span>
                            </el-form-item>
                            <el-form-item label="证书有效期限至 : " prop="businessFailTime" size="small">
                                <span>{{ruleForm.businessFailTime | dateStrIntercept}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="证书编号 : " prop="certNum" size="small">
                                <span>{{ruleForm.certNum}}</span>
                            </el-form-item>
                            <el-form-item label="颁发日期 : " prop="awardTime" size="small">
                                <span>{{ruleForm.awardTime | dateStrIntercept}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="国别/地区 : " prop="nation" size="small">
                                <span>{{ruleForm.nationName}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="注册资本 : " prop="registerCapital" size="small">
                                <span>{{ruleForm.registerCapital}}万元</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="成立日期 : " prop="incorporationTime" size="small">
                                <span>{{ruleForm.incorporationTime | dateStrIntercept}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="企业类型 : " prop="unitProperty" size="small">
                                <span>{{ruleForm.unitPropertyName}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="国民经济行业分类 : " prop="industryCode" size="small">
                                <span>{{ruleForm.industryCodeName}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-form-item label="单位地址 : " prop="regionCode" size="small">
                                <span>{{ruleForm.regionCodeFullName}}&nbsp;&nbsp;&nbsp;&nbsp;{{ruleForm.address}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="经营范围 : " prop="businessScope">
                                <span style="margin-top: 8.5px;">{{ruleForm.businessScope}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="card-item">
                <div class="card-title">
                    <span>联系人信息</span>
                </div>
                <div class="card-content">
                    <el-row>
                        <el-col>
                            <el-form-item label="法定代表人身份证信息 : " prop="orgAbovePhotoAddr">
                                <el-row>
                                    <el-col :span="8">
                                        <imgUploadView v-if="ruleForm.businessPhotoAddr" :ruleForm.sync="ruleForm" :backgroundType="1" :imgUrl.sync="ruleForm.orgAbovePhotoAddr"/>
                                    </el-col>
                                    <el-col :span="8">
                                        <imgUploadView v-if="ruleForm.businessPhotoAddr" :ruleForm.sync="ruleForm" :backgroundType="1" :imgUrl.sync="ruleForm.orgBelowPhotoAddr"/>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="法定代表人 : " prop="orgLegal" size="small">
                                <span>{{ruleForm.orgLegal}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="法定代表人手机号 : " prop="orgLegalTel" size="small">
                                <span>{{ruleForm.orgLegalTel}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="法定代表人证件信息 : " prop="orgCertType" size="small">
                                <span>{{ruleForm.orgCertTypeName}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="法定代表人证件号码 : " prop="legalIdCard" size="small">
                                <span>{{ruleForm.legalIdCard}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="负责人 : " prop="responsible" size="small">
                                <span>{{ruleForm.responsible}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="负责人手机号 : " prop="linkPhone" size="small">
                                <span>{{ruleForm.linkPhone}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="申报人 : " prop="infoResponsible" size="small">
                                <span>{{ruleForm.infoResponsible}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="申报人手机号 : " prop="infoResponsiblePhone" size="small">
                                <span>{{ruleForm.infoResponsiblePhone}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="驻本地联系人 : " prop="regionalHead" size="small">
                                <span>{{ruleForm.regionalHead}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="驻本地联系人手机号 : " prop="areaResponsibleTel" size="small">
                                <span>{{ruleForm.areaResponsibleTel}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="公司传真 : " prop="fax" size="small">
                                <span>{{ruleForm.fax}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-form-item label="驻本地地址 : " prop="areaCode" size="small">
                                <span>{{ruleForm.areaAddressName}}&nbsp;&nbsp;&nbsp;&nbsp;{{ruleForm.areaAddress}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="card-item">
                <div class="card-title">
                    <span>银行账户信息</span>
                </div>
                <div class="card-content">
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="基本账户扫描件 : " prop="bankPhotoAddr" size="small">
                                <imgUploadView v-if="ruleForm.businessPhotoAddr" :ruleForm.sync="ruleForm" :backgroundType="1" :imgUrl.sync="ruleForm.bankPhotoAddr"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="所属银行 : " prop="mainBank" size="small">
                                <span>{{ruleForm.mainBankName}}</span>
                            </el-form-item>
                            <el-form-item label="开户行城市 : " prop="bankCity" size="small">
                                <span>{{ruleForm.bankCityName}}</span>
                            </el-form-item>
                            <el-form-item label="开户行名称 : " prop="depositBank" size="small">
                                <span>{{ruleForm.depositBank}}</span>
                            </el-form-item>
                            <el-form-item label="基本账户账号 : " prop="amountNum" size="small">
                                <span>{{ruleForm.amountNum}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    export default {
        name: "main-basicInfo-form",
        data() {
            return {
                type: 'ent_base_info',
                id:'',
                ruleForm: {
                    mainCode: '',//统一社会信用代码
                    mainName: '',//主体名称
                    agencyCode: '',//法人机构类别
                    agencyCodeName:'',
                    roleType: [],//交易主体角色类型
                    roleTypeArr: [],//交易主体角色类型--arr
                    businessPhotoAddr: '',//营业执照
                    certName: '',//证书名称
                    awardDepart: '',//颁发部门
                    businessFailTime: '',//证书有效期限至
                    certNum: '',//证书编号
                    awardTime: '',//颁发日期
                    nation: '',//国别地区
                    nationName: '',//国别地区
                    registerCapital: '',//注册资本
                    incorporationTime: '',//成立日期
                    unitProperty: '',//企业类型
                    unitPropertyName: '',//企业类型
                    industryCode: '',//国民经济行业分类
                    industryCodeName: '',//国民经济行业分类
                    regionCode: [],//单位地址
                    regionFullCode: [],//单位地址 -- 展示
                    address: '',//单位地址
                    businessScope: '',//经营范围
                    orgAbovePhotoAddr: '',//法定代表人身份证正面
                    orgBelowPhotoAddr: '',//法定代表人身份证反面
                    orgLegal: '',//法定代表人
                    orgLegalTel: '',//法定代表人手机号
                    orgCertType: '',//法定代表人证件信息
                    orgCertTypeName: '',//法定代表人证件信息
                    legalIdCard: '',//法定代表人身份证号
                    responsible: '',//负责人
                    linkPhone: '',//负责人手机号
                    infoResponsible: '',//申报人
                    infoResponsiblePhone: '',//申报人手机号
                    regionalHead: '',//驻本地联系人
                    areaResponsibleTel: '',//驻本地联系人手机号
                    fax:'',
                    areaCode: [],//驻本地地址
                    areaFullCode: [],//驻本地地址 -- 展示
                    areaAddress: '',//驻本地地址
                    bankPhotoAddr: '',//基本户扫描件
                    mainBank: '',//所属银行
                    mainBankName: '',//所属银行
                    depositBank: '',//开户行名称
                    amountNum: '',//基本账户账号
                    bankCity: [],//开户行城市
                    bankCityName: '',//开户行城市
                    bankFullCity: [],//开户行城市 -- 展示
                    attachmentParamList: [{//附件列表
                        Id: "",
                        citeId: "",
                        name: "",
                        fileType: 1,
                        filePath: "",
                        required: false,
                        attributes: {
                            attname: "",
                            delmethod: "2",
                            allows: '.pdf,.PDF'
                        }
                    }],
                    fileList: [],//附件类型上传校验
                },
            }
        },
        created(){
            this.getRouterQuery();
            this.getBasicInfoMsg();
        },
        activated() {
            this.getRouterQuery();
            this.getBasicInfoMsg();
        },
        methods: {
            getRouterQuery(){
                this.id = this.$route.query.id;
            },
            getBasicInfoMsg(){
                this.$http.post('/tenderer/entbaseinfo/getbyid?id='+this.id).then(res=>{
                    if(res.data.code == 1 && res.data.data){
                        this.ruleForm.mainCode = res.data.data.mainCode || '';//统一社会信用代码
                        this.ruleForm.mainName = res.data.data.mainName || '';//主体名称
                        this.ruleForm.agencyCode = res.data.data.agencyCode || '';//法人机构类别
                        this.ruleForm.agencyCodeName = res.data.data.agencyCodeName || '';//法人机构类别
                        if(res.data.data.roleType && res.data.data.roleType.length > 0){
                            this.ruleForm.roleTypeArr = res.data.data.roleType.split('')
                        }else{
                            this.ruleForm.roleTypeArr = [];
                        }
                        this.ruleForm.businessPhotoAddr = res.data.data.businessPhotoAddr || '';//营业执照
                        this.ruleForm.certName = res.data.data.certName || '';//证书名称
                        this.ruleForm.awardDepart = res.data.data.awardDepart || '';//颁发部门
                        this.ruleForm.businessFailTime = res.data.data.businessFailTime || '';//证书有效期限至
                        this.ruleForm.certNum = res.data.data.certNum || '';//证书编号
                        this.ruleForm.awardTime = res.data.data.awardTime || '';//颁发日期
                        this.ruleForm.nation = res.data.data.nation || '';//国别地区
                        this.ruleForm.nationName = res.data.data.nationName || '';//国别地区
                        this.ruleForm.registerCapital = res.data.data.registerCapital || '';//注册资本
                        this.ruleForm.incorporationTime = res.data.data.incorporationTime || '';//成立日期
                        this.ruleForm.unitProperty = res.data.data.unitProperty || '';//企业类型
                        this.ruleForm.unitPropertyName = res.data.data.unitPropertyName || '';//企业类型
                        this.ruleForm.industryCode = res.data.data.industryCode || '';//国民经济行业分类
                        this.ruleForm.industryCodeName = res.data.data.industryCodeName || '';//国民经济行业分类
                        this.ruleForm.address = res.data.data.address || '';//单位地址
                        this.ruleForm.regionCodeFullName = res.data.data.regionCodeFullName || '';//单位地址
                        this.ruleForm.businessScope = res.data.data.businessScope || '';//经营范围
                        this.ruleForm.orgAbovePhotoAddr = res.data.data.orgAbovePhotoAddr || '';//法定代表人身份证正面
                        this.ruleForm.orgBelowPhotoAddr = res.data.data.orgBelowPhotoAddr || '';//法定代表人身份证反面
                        this.ruleForm.orgLegal = res.data.data.orgLegal || '';//法定代表人
                        this.ruleForm.orgLegalTel = res.data.data.orgLegalTel || '';//法定代表人手机号
                        this.ruleForm.orgCertType = res.data.data.orgCertType || '';//法定代表人证件信息
                        this.ruleForm.orgCertTypeName = res.data.data.orgCertTypeName || '';//法定代表人证件信息
                        this.ruleForm.legalIdCard = res.data.data.legalIdCard || '';//法定代表人身份证号
                        this.ruleForm.responsible = res.data.data.responsible || '';//负责人
                        this.ruleForm.linkPhone = res.data.data.linkPhone || '';//负责人手机号
                        this.ruleForm.infoResponsible = res.data.data.infoResponsible || '';//申报人
                        this.ruleForm.infoResponsiblePhone = res.data.data.infoResponsiblePhone || '';//申报人手机号
                        this.ruleForm.regionalHead = res.data.data.regionalHead || '';//驻本地联系人
                        this.ruleForm.areaResponsibleTel = res.data.data.areaResponsibleTel || '';//驻本地联系人手机号
                        this.ruleForm.fax = res.data.data.fax;//公司传真
                        this.ruleForm.areaAddress = res.data.data.areaAddress || '';//驻本地地址
                        this.ruleForm.bankPhotoAddr = res.data.data.bankPhotoAddr || '';//基本户扫描件
                        this.ruleForm.mainBank = res.data.data.mainBank || '';//所属银行
                        this.ruleForm.mainBankName = res.data.data.mainBankName || '';//所属银行
                        this.ruleForm.depositBank = res.data.data.depositBank || '';//开户行名称
                        this.ruleForm.amountNum = res.data.data.amountNum || '';//基本账户账号
                        this.ruleForm.bankCity = res.data.data.bankCity || [];//开户行城市
                        this.ruleForm.bankCityName = res.data.data.bankCityName || '';//开户行城市
                        if(res.data.data.attachmentParamList.length > 0){
                            this.ruleForm.attachmentParamList = res.data.data.attachmentParamList;//附件列表
                        }
                    }

                })
            }
        },
        filters:{
            dateStrIntercept(str){
                if(str){
                    return str.substring(0,11);
                }else{
                    return '--'
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .container {
        /deep/ .el-input {
            width: 324px;
        }
        .card-content{
            span{
                display:inline-block;
                line-height: 24px!important;
                color: rgba(0,0,0,0.65);
            }
        }
        /deep/ .el-textarea__inner {
            width: 658px;
            height: 156px;
        }
        .all-deal-type {
            display: flex;
            .item-deal-type {
                width: 480px;
                border: 1px solid #EEEEEE;
                border-radius: 4px 4px 0px 0px;
                .item-deal-title {
                    width: 100%;
                    height: 45px;
                    background-color: #EFF3F6;
                    border-radius: 2px 2px 0px 0px;
                    border-bottom: 1px solid #EEEEEE;
                    text-align: center;
                    line-height: 45px;
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.85);
                }
                .item-deal-content {
                    padding: 15px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }
            }

            .item-deal-type:nth-last-child(1) {
                border-left: 0;
            }
        }
    }
</style>